import { render, staticRenderFns } from "./ClassicModal.vue?vue&type=template&id=664b43ef&scoped=true"
import script from "./ClassicModal.vue?vue&type=script&lang=js"
export * from "./ClassicModal.vue?vue&type=script&lang=js"
import style0 from "./ClassicModal.vue?vue&type=style&index=0&id=664b43ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664b43ef",
  null
  
)

export default component.exports